<template>
  <div class="mt8 formData">
    <van-form @submit.stop.prevent="onSubmit" ref="dataForms" :disabled="isDisabled">
      <div class="modulesWrap">
        <div class="cardWrap">
          <div class="cardTitle">填写个人信息</div>
        </div>
        <template class="everyForm">
          <van-field required v-model="dataForm.mobilePhoneNum" type="tel" center label="手机号" label-width="80px"
            :disabled="Boolean($store.state.token && dataForm.studentId)"
            :rules="[{ required: true, validator: rulesMobilePhoneNum }]" placeholder="请输入手机号">
          </van-field>
        </template>
        <div class="everyForm" v-if="!this.$store.state.token">
          <van-field required v-model="dataForm.code" type="digit" center label="验证码" label-width="80px"
            :rules="[{ required: true }]" @change.stop.prevent="userInfoFn" placeholder="请输入短信验证码">
            <template #button>
              <van-button size="small" type="danger" native-type="button" @click.stop="sendCodeFn" class="getCodeBtn">{{
                codeNum != 60 ? codeNum + "(s)" : "发送验证码"
              }}</van-button>
            </template>
          </van-field>
        </div>
        <template class="everyForm">
          <van-field required readonly clickable label-width="75px" v-model="dataForm.identityTypeName" label="证件类型"
            right-icon="arrow-down" input-align="right" placeholder="请选择证件类型" :rules="[{ required: true }]"
            :disabled="Boolean($store.state.token && dataForm.studentId)" @click.stop="showIdentityType = true" />
          <van-popup v-model="showIdentityType" position="bottom">
            <van-picker show-toolbar :columns="zjlxList" value-key="name" @confirm="identityTypeConfirm"
              @cancel="showIdentityType = false" />
          </van-popup>
        </template>
        <template class="everyForm">
          <van-field required dlabel-width="75px" v-model.trim="dataForm.name" label="姓名" placeholder="请与证件上保持一致"
            :rules="[{ required: true }]" :disabled="Boolean($store.state.token && dataForm.studentId)" />
        </template>
        <template class="everyForm">
          <van-field required dlabel-width="75px" v-model.trim="dataForm.identityNum" maxlength="18" label="证件号"
            placeholder="请与证件上保持一致" :disabled="Boolean($store.state.token && dataForm.studentId)"
            :rules="[{ required: true, validator: rulesIdentityNum }]" />
        </template>
        <template class="everyForm">
          <van-field required v-model="dataForm.email" center label="邮箱" label-width="80px"
            :rules="[{ required: true, validator: rulesEmail }]" placeholder="请输入邮箱">
          </van-field>
        </template>
        <div class="tip">*用于建立唯一报读账号，请填写本人真实信息</div>
      </div>
      <div class="modulesWrap">
        <div class="cardWrap">
          <div class="cardTitle twoTitle">
            <span>报读意向</span>
            <div class="ditu" @click="getLocation">
              <img src="@/assets/img/dizhi-xuanzhong@2x.png" />
              <span>{{ dataForm.area }}</span>
            </div>
          </div>
        </div>
        <template class="everyForm">
          <van-field required readonly clickable dlabel-width="75px" v-model="dataForm.oldDegreeLevelName" label="前置学历"
            right-icon="arrow-down" input-align="right" placeholder="请选择前置学历" :rules="[{ required: true }]"
            @click.stop="showOldDegreeLevel = true" />
          <van-popup v-model="showOldDegreeLevel" position="bottom">
            <van-picker show-toolbar :columns="yxlccLists" value-key="name" @confirm="oldDegreeLevelConfirm"
              @cancel="showOldDegreeLevel = false" />
          </van-popup>
          <div class="degreeTip">
            注：初中起点学生可修两年制或三年制专业，两年制学生需年满16周岁，三年制学生需年满15周岁；高中及以上起点学生可修一年制专业，需年满18周岁
          </div>
        </template>
        <div class="template">
          <div class="templateOne" v-if="majorTypeActive === 0">
            <!-- 公众号 -->
            <!-- <template v-if="dataForm.registrationChannel == 1"> -->
            <template>
              <template class="everyForm">
                <van-field required clickable readonly dlabel-width="75px" v-model="dataForm.branchName" label="所在分校"
                  right-icon="arrow-down" input-align="right" placeholder="请选择所在分校" :rules="[{ required: true }]"
                  @click.stop="showBranchId = true" />
                <van-popup v-model="showBranchId" position="bottom">
                  <van-search v-model="branchSearchValue" placeholder="请输入所在分校" :show-action="showAction"
                    @search.stop="() => searchBranch" @focus="() => showAction = true"
                    @cancel="() => showAction = false">
                    <div slot="action">
                      {{ branchSearchValue ? '搜索' : '取消' }}
                    </div>
                  </van-search>
                  <van-picker show-toolbar :columns="branchSearchValue ? fxListFilter(fxList) : fxList"
                    value-key="schoolName" @confirm="showBranchIdConfirm" @cancel="showBranchId = false" />
                </van-popup>
              </template>
              <template class="everyForm">
                <van-field required clickable readonly dlabel-width="75px" v-model="dataForm.schoolName" label="教学中心"
                  right-icon="arrow-down" input-align="right" placeholder="请选择教学中心" :rules="[{ required: true }]"
                  @click.stop="showSchoolId = true" />
                <van-popup v-model="showSchoolId" position="bottom">
                  <van-search v-model="schoolSearchValue" placeholder="请输入教学中心" :show-action="showSchoolAction"
                    @search.stop="() => schoolBranch" @focus="() => showSchoolAction = true"
                    @cancel="() => showSchoolAction = false">
                    <div slot="action">
                      {{ schoolSearchValue ? '搜索' : '取消' }}
                    </div>
                  </van-search>

                  <van-picker show-toolbar :columns="schoolSearchValue ? xxzxListFilter(xxzxList) : xxzxList"
                    value-key="schoolName" @confirm="showSchoolIdConfirm" @cancel="showSchoolId = false" />
                </van-popup>
              </template>
            </template>
            <!-- 其他 -->
            <!-- <template v-else>
              <van-field
                required
                v-model="dataForm.branchName"
                center
                label="所在分校"
                label-width="80px"
                disabled
              ></van-field>
              <van-field
                required
                v-model="dataForm.schoolName"
                center
                label="教学中心"
                label-width="80px"
                disabled
              ></van-field>
            </template> -->
            <template class="everyForm">
              <van-field required clickable readonly :border="false" dlabel-width="75px" v-model="dataForm.planName"
                label="专业名称" right-icon="arrow-down" input-align="right" placeholder="请选择专业名称"
                :rules="[{ required: true }]" @click.stop="showSpecialtyId = true" />
              <van-popup v-model="showSpecialtyId" position="bottom">
                <van-picker show-toolbar :columns="zymcList" value-key="planName" @confirm="showSpecialtyIdConfirm"
                  @cancel="showSpecialtyId = false" />
              </van-popup>
            </template>
          </div>
          <div class="templateOne" v-if="majorTypeActive === 1">
            <template class="everyForm">
              <van-field required clickable readonly :border="false" dlabel-width="75px" v-model="dataForm.planName"
                label="专业名称" right-icon="arrow-down" input-align="right" placeholder="请选择专业名称"
                :rules="[{ required: true }]" @click.stop="showSpecialtyId = true" />
              <van-popup v-model="showSpecialtyId" position="bottom">
                <van-picker show-toolbar :columns="zymcList" value-key="planName" @confirm="showSpecialtyIdConfirm"
                  @cancel="showSpecialtyId = false" />
              </van-popup>
            </template>
            <template class="everyForm">
              <van-field required clickable readonly dlabel-width="75px" v-model="dataForm.branchName" label="所在分校"
                right-icon="arrow-down" input-align="right" placeholder="请选择所在分校" :rules="[{ required: true }]"
                @click.stop="showBranchId = true" />
              <van-popup v-model="showBranchId" position="bottom">
                <van-picker show-toolbar :columns="fxList" value-key="schoolName" @confirm="showBranchIdConfirm"
                  @cancel="showBranchId = false" />
              </van-popup>
            </template>
            <template class="everyForm">
              <van-field required clickable :border="false" readonly dlabel-width="75px" v-model="dataForm.schoolName"
                label="教学中心" right-icon="arrow-down" input-align="right" placeholder="请选择教学中心"
                :rules="[{ required: true }]" @click.stop="showSchoolId = true" />
              <van-popup v-model="showSchoolId" position="bottom">
                <van-picker show-toolbar :columns="xxzxList" value-key="schoolName" @confirm="showSchoolIdConfirm"
                  @cancel="showSchoolId = false" />
              </van-popup>
            </template>
          </div>
        </div>
      </div>
    </van-form>
  </div>
</template>
<script>
import { sendCode, phoneLogin, getStudentInfo ,getByTypeAndLevel} from "@/api/login";
import { Toast } from "vant";
import { Dialog } from 'vant'
import Mixins from "./component/location";
import { isMobile, checkEmail } from "../../../utils/validate";
import {
  industryCollegesList,
  getChildrensByParentId,
  getTeachPlanBySchoolId,
  getTeachPlanBySchoolIdAndEducation,
  getCollegeTeachPlanList,
  saveData,
} from "@/api/home";
export default {
  name: "homes",
  data() {
    return {
      branchSearchValue: '', // 搜索学校名称
      schoolSearchValue: '', // 搜索教学中心名称
      showAction: false, // 是聚焦
      showSchoolAction: false, // 是否聚焦
      codeNum: 60, // 验证码
      timer: null,
      isDisabled: false, // 是否禁用
      zjlxList: [], // 证件类型
      zymcList: [], // 专业数据
      zymcOldList: [], // oldList
      yxlccLists: [], // 原学历层次
      fxList: [], // 所在分校列表
      xxzxList: [], // 教学中心列表
      majorTypeActive: 0,
      majorType: ["按照教学中心选专业", "按照专业选教学中心"],
      xzList: [], // 学制
      zyxzDataList: [], // 学制所有数据
      // 弹窗
      showIdentityType: false, // 证件类型
      showOldDegreeLevel: false, // 前置学历
      showBranchId: false, // 所在分校
      showSchoolId: false, // 教学中心
      showSpecialtyId: false, // 专业名称
      showYearSystem: false,
      studentInfoData: {}, // 存储接口返回的学生信息，用于弹框展示
      dataForm: {
        name: "", // 姓名
        identityType: "", // 证件类型
        identityTypeName: "", // 证件类型名称
        identityNum: "", // 证件号码
        email: "", // 邮箱
        mobilePhoneNum: "", // 手机号码
        code: "",
        oldDegreeLevel: "", // 前置学历
        oldDegreeLevelName: "", // 前置学历名称
        branchId: "", // 所在分校id
        branchName: "", // 所在分校名称
        schoolId: "", // 教学中心
        schoolName: "", // 教学中心名称
        specialtyId: "", // 专业名称
        specialtyName: "", // 专业名称
        yearSystem: "", // 年制
        yearSystemName: "", // 学制名称
        registrationChannel: "1", // 报名渠道
        area: "", // 默认位置为空，不设置默认值
      },
    };
  },
  props: ["openId"],
  watch: {
    stepActive: {
      handler(newValue) {
        if (newValue == 0) {
          // 第一步
          this.getByTypeRequest();
        }
      },
      deep: true,
      setImmediate: true,
    },
  },
  created() {
    this.dataForm.openId = this.$route.query.openId || this.openId;
    this.getByTypeRequest();
  },
  mixins: [Mixins],
  mounted() {
    // 判断是否是修改报名信息进入（有 studentId 参数且已登录）
    const isModifying = this.$route.query.studentId && this.$store.state.token;
    
    if (!isModifying) {
      // 页面刷新时清除登录状态，让用户重新登录填写信息
      this.dataForm.studentId = "";
      console.log("111aifff",this.$store.state.token);
      this.studentInfoData = {};
      this.$store.commit("setToken", "");
      this.$store.commit("setUserId", "");
      this.$store.commit("setStudentNo", "");
      localStorage.clear();
    } else {
      // 修改报名信息模式：保留登录状态，获取学生信息回显
      console.log("修改报名信息模式，保留登录状态");
      this.getStudentInfoFn();
    }
    
    // 初始化时获取分校数据（不传位置参数，获取全部分校）
    this.getIndustryCollegesRequest();
    // 尝试获取当前位置，成功后刷新分校列表
    this.getLocation(() => {
      // 如果获取位置成功，重新获取分校数据
      if (this.dataForm.area) {
        this.getIndustryCollegesRequest();
      }
    });
  },
  methods: {
    // 获取信息
    userInfoFn() {
      localStorage.clear();
      let { code, mobilePhoneNum } = this.dataForm;
      if (!mobilePhoneNum || !this.rulesMobilePhoneNum(mobilePhoneNum)) {
        Toast({
          message: "请输入正确的手机号",
          position: "top",
        });
        return;
      }
      if (!code) {
        Toast({
          message: "请输入验证码",
          position: "top",
        });
        return;
      }
      if (code && mobilePhoneNum) {
        phoneLogin({
          phone: mobilePhoneNum,
          code,
          openId: this.dataForm.openId,
        })
          .then((res) => {
            if (res && res.token) {
              this.$store.commit("setToken", res.token || "");
              this.$store.commit("setUserId", res.userId || "");
              this.$store.commit("setStudentNo", res.studentNo || "");
              this.getStudentInfoFn();
            }
          })
          .catch((err) => {
            this.$store.commit("setToken", "");
            this.$store.commit("setUserId", "");
            this.isDisabled = false;
            let kongObj = {
              name: "", // 姓名
              identityType: "", // 证件类型
              identityTypeName: "", // 证件类型名称
              identityNum: "", // 证件号码
              email: "", // 邮箱
              oldDegreeLevel: "", // 前置学历
              oldDegreeLevelName: "", // 前置学历名称
              branchId: "", // 所在分校id
              branchName: "", // 所在分校名称
              schoolId: "", // 教学中心
              schoolName: "", // 教学中心名称
              specialtyId: "", // 专业名称
              specialtyName: "", // 专业名称
              yearSystem: "", // 年制
              yearSystemName: "", // 学制名称
              registrationChannel: "1", // 报名渠道
              openId: this.openId,
            };
            Object.keys(kongObj).forEach((key) => {
              this.dataForm[key] = kongObj[key];
            });
          });
      }
    },
    // 数据回显
    async showDataFn(data) {
      if (data.planId) {
        const planNameItem = this.zymcList.filter(
          (item) => item.planId == data.planId
        );
        data.planName = planNameItem && planNameItem.length ? planNameItem[0].planName : ""
        Object.assign(this.dataForm, data);
      } else {
        Object.assign(this.dataForm, data);
      }
    },
    // 获取code
    sendCodeFn() {
      if (this.timer) {
        return;
      }
      let phone = this.dataForm.mobilePhoneNum;
      if (!phone || !this.rulesMobilePhoneNum(phone)) {
        Toast({
          message: "请输入正确的手机号",
          position: "top",
        });
        return;
      }
      sendCode({ phone }).then((res) => {
        this.timer = setInterval(() => {
          this.codeNum = --this.codeNum;
          if (this.codeNum <= 0) {
            this.codeNum = 60;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      });
    },
    // 初始化
    getByTypeRequest() {
      // 证件类型
      this.$getByType({ code: "SFZJLX" }).then((res) => {
        this.zjlxList = res;
        let cur = res.filter((item) => item.code == 1);
        if (cur && cur.length) {
          this.$set(this.dataForm, "identityTypeName", res[0].name);
          this.$set(this.dataForm, "identityType", res[0].code);
        }
      });
      // 原学历层次
      this.$getByType({ code: "XL" }).then((res) => {
        this.yxlccLists = res;
        console.log(res, '222222222222233学历');
      });
      // 学制
      this.$getByType({ code: "zyxz" }).then((res) => {
        this.zyxzDataList = res;
      });
    },
    // 获取弹框数据
    async getDisplayData() {
      let { code, mobilePhoneNum } = this.dataForm;
      if (code && mobilePhoneNum) {
        try {
          const loginRes = await phoneLogin({
            phone: mobilePhoneNum,
            code,
            openId: this.dataForm.openId,
          });
          console.log(loginRes, '登录结果22');
          
          // 学生还没有报名，执行清除逻辑并返回，阻止后续弹框
          if (loginRes === '验证码无效') {
            // 清除用户填写的信息
            let kongObj = {
              name: "", // 姓名
              identityType: "", // 证件类型
              identityTypeName: "", // 证件类型名称
              identityNum: "", // 证件号码
              email: "", // 邮箱
              mobilePhoneNum: "", // 手机号码
              code: "", // 验证码
              oldDegreeLevel: "", // 前置学历
              oldDegreeLevelName: "", // 前置学历名称
              branchId: "", // 所在分校id
              branchName: "", // 所在分校名称
              schoolId: "", // 教学中心
              schoolName: "", // 教学中心名称
              specialtyId: "", // 专业名称
              specialtyName: "", // 专业名称
              yearSystem: "", // 年制
              yearSystemName: "", // 学制名称
              planId: "", // 计划id
              planName: "", // 计划名称
              classId: "", // 班级
              studentId: "", // 学生ID
            };
            Object.keys(kongObj).forEach((key) => {
              this.dataForm[key] = kongObj[key];
            });
            // 重置禁用状态
            this.isDisabled = false;
            // 清除验证码倒计时
            if (this.timer) {
              clearInterval(this.timer);
              this.timer = null;
              this.codeNum = 60;
            }
            // 清除Vuex中的登录状态
            this.$store.commit("setToken", "");
            this.$store.commit("setUserId", "");
            this.$store.commit("setStudentNo", "");
            // 清除localStorage
            localStorage.clear();
            // 清除弹框展示的接口数据
            this.studentInfoData = {};
            Toast({
              message: "验证码无效，请重新登录",
              position: "top",
            });
            return;
          }
           if (loginRes === '学生还没有报名') {
            // 只清除第二页（improveInfor）和第三页（Sign）的数据，第一页数据保留
            this.clearOtherPageData();
           
          }
          if (loginRes && loginRes.token) {
            this.$store.commit("setToken", loginRes.token || "");
            const studentRes = await getStudentInfo();
            if (studentRes) {
              // 保存接口返回的学生信息，用于弹框展示
              this.studentInfoData = studentRes || {};
              // 如果学生未报名（没有studentId），清除第二页和第三页的数据
              if(!this.studentInfoData.oldGraduated){
                  this.clearOtherPageData();
              }
              // this.$store.commit("setToken", "");
              console.log(this.studentInfoData, '学生信息22');
            }
          }
        } catch (error) {
          console.error('获取弹框数据失败:', error);
        }
      }
    },
    getStudentInfoFn() {
       console.log("111ai",this.$store.state.token);
      getStudentInfo().then(async (res) => {
        if (res) {
          // 保存接口返回的学生信息，用于弹框展示
          // this.studentInfoData = res.data || {};
          this.isDisabled = !(
            res.approvalStatus == 0 ||
            res.approvalStatus == 1 
            // res.approvalStatus == 3 ||
            // res.approvalStatus == 6 ||
            // res.approvalStatus == 9
          );
          this.getSchoolRequest({ branchId: res.branchId, area: res.area }); // 获取教学中心数据
          // 如果已有前置学历，根据前置学历获取专业列表
          if (res.oldDegreeLevel && res.schoolId) {
            await this.getMajorListByEducation(res.schoolId, res.oldDegreeLevel);
          } else {
            await this.getMajorListRequest(res.schoolId);
          }
          this.showDataFn(res);
          // 如果已有年制，根据年制更新前置学历列表
          if (res.yearSystem) {
            await this.getEducationListByYear();
          }
        } else {
          localStorage.clear();
          window.location.reload(); //监测到路由发生跳转时刷新一次页面
        }
      });
    },
    // 证件类型改变
    identityTypeConfirm(e) {
      this.dataForm.identityType = e.code;
      this.dataForm.identityTypeName = e.name;
      this.showIdentityType = false;
    },
    // 前置学历改变
    async oldDegreeLevelConfirm(e) {
      this.dataForm.oldDegreeLevel = e.code;
      this.dataForm.oldDegreeLevelName = e.name;
      this.showOldDegreeLevel = false;
      // 根据前置学历更新专业列表（如果已选择教学中心）
      if (this.dataForm.schoolId) {
        await this.getMajorListByEducation();
      }
    },
    // 方式改变
    async majorTypeChange(active) {
      if (this.dataForm.registrationChannel != 1) {
        // 公众号
        return;
      }
      this.majorTypeActive = active;
      this.fxList = [];
      this.xxzxList = [];
      this.zymcList = [];
      this.dataForm.planId = ''; // 计划id
      this.dataForm.planName = ''; // 计划名称
      this.dataForm.yearSystem = "";
      this.dataForm.yearSystemName = "";
      this.dataForm.branchId = "";
      this.dataForm.branchName = "";
      this.dataForm.schoolId = "";
      this.dataForm.schoolName = "";
      this.dataForm.specialtyId = "";
      this.dataForm.specialtyName = "";
      if (!active) {
        // 按照教学中心选专业
        this.getIndustryCollegesRequest();
      } else {
        this.zymcList = await getCollegeTeachPlanList()

      }

    },
    // 所在分校改变
    showBranchIdConfirm(e) {
      if (!e) {
        this.showBranchId = false;
        return;
      }
      this.dataForm.branchId = e[0]?.schoolId || "";
      this.dataForm.branchName = e[0]?.schoolName || "";
      if (this.majorTypeActive === 0) {
        //  按教学中心选专业
        this.dataForm.specialtyId = "";
        this.dataForm.specialtyName = "";
        this.zymcList = [];
      }
      this.dataForm.schoolId = "";
      this.dataForm.schoolName = "";
      this.xxzxList = [];
      this.schoolSearchValue = '' // 教学中心搜索条件
      this.getSchoolRequest();
      this.showBranchId = false;
    },
    // 教学中心
    async showSchoolIdConfirm(e) {
      if (!e) {
        this.showSchoolId = false;
        return;
      }
      this.dataForm.schoolId = e[0]?.schoolId || "";
      this.dataForm.schoolName = e[0]?.schoolName || "";
      if (this.majorTypeActive === 0) {
        //  按教学中心选专业
        this.dataForm.specialtyId = '';
        this.dataForm.specialtyName = '';
        this.dataForm.yearSystem = ''; // 学制
        this.dataForm.yearSystemName = ''; // 学制
        this.dataForm.planId = ''; // 计划id
        this.dataForm.planName = ''; // 计划名称
        this.zymcList = [];
        // 如果已选择前置学历，根据前置学历获取专业列表
        if (this.dataForm.oldDegreeLevel) {
          await this.getMajorListByEducation(this.dataForm.schoolId, this.dataForm.oldDegreeLevel);
        } else {
          await this.getMajorListRequest();
        }
      }
      this.showSchoolId = false;
    },
    // 专业名称
    async showSpecialtyIdConfirm(e) {
      if (!e) {
        this.showSpecialtyId = false;
        return;
      }
      this.dataForm.specialtyId = String(e.professionId || '');
      this.dataForm.specialtyName = e.professionName;
      this.dataForm.yearSystem = e.years; // 学制
      this.dataForm.yearSystemName = e.yearsName; // 学制
      this.dataForm.planId = e.planId; // 计划id
      this.dataForm.planName = e.planName; // 计划名称
      this.dataForm.classId = ""; // 班级为空
      
      // 根据年制获取可报读的前置学历列表
      if (this.dataForm.yearSystem) {
        await this.getEducationListByYear();
      }
      
      if (this.majorTypeActive != 0) {
        //  按专业选教学中心
        this.dataForm.branchId = "";
        this.dataForm.branchName = "";
        this.dataForm.schoolId = "";
        this.dataForm.schoolName = "";
        this.fxList = [];
        this.xxzxList = [];
        this.getIndustryCollegesRequest();
      }
      this.showSpecialtyId = false;
    },
    // 获取年龄方法
    getAgeFn() {
      if (this.dataForm.identityType == 1) {
        // 身份证
        let idNo = this.dataForm.identityNum;
        if (!idNo || idNo.length !== 18) {
          return 0;
        }
        let str1 = idNo.substring(6, 10);
        let str2 = idNo.substring(10, 12);
        let str3 = idNo.substring(12, 14);
        let myDate = new Date();
        let month = myDate.getMonth() + 1;
        let day = myDate.getDate();
        let age = myDate.getFullYear() - str1 - 1;
        if (str2 < month || (str2 == month && str3 <= day)) {
          age++;
        }
        return age;
      }
      // 非身份证类型，默认返回99岁避免误判
      return 99;
    },
    // 分校过来
    fxListFilter(list) {
      let filterList = list[0].values.filter(item => item.schoolName.includes(this.branchSearchValue))
      return [{ values: filterList }]
    },
    // 获取所有分部
    async getIndustryCollegesRequest() {
      // 没有位置信息时不传 areaName，获取全部分校
      const params = this.dataForm.area ? { areaName: this.dataForm.area } : {};
      let arrList = await industryCollegesList(params);
      this.fxList = [{ values: arrList }];
    },
    xxzxListFilter(list) {
      let filterList = list[0].values.filter(item => item.schoolName.includes(this.schoolSearchValue))
      return [{ values: filterList }]
    },
    // 获取教学中心数据
    async getSchoolRequest(dataForm) {
      const branchId = dataForm ? dataForm.branchId : this.dataForm.branchId;
      const areaName = dataForm ? dataForm.area : this.dataForm.area;
      const params = { branchId: branchId };
      if (areaName) {
        params.areaName = areaName;
      }
      const res = await getChildrensByParentId(params);
      this.$set(this, "xxzxList", [{ values: res || [] }]);
    },

    // 获取专业名称列表
    async getMajorListRequest(schoolId) {
      this.zymcList = await getTeachPlanBySchoolId({ schoolId: schoolId ? schoolId : this.dataForm.schoolId })
    },
    // 根据前置学历获取专业列表
    async getMajorListByEducation(schoolId, education) {
      const targetSchoolId = schoolId || this.dataForm.schoolId;
      const targetEducation = education || this.dataForm.oldDegreeLevel;
      if (!targetSchoolId || !targetEducation) {
        return;
      }
      try {
        this.zymcList = await getTeachPlanBySchoolIdAndEducation({
          schoolId: targetSchoolId,
          education: targetEducation
        });
      } catch (error) {
        console.error('获取专业列表失败:', error);
        // 如果接口失败，使用原来的接口
        await this.getMajorListRequest(targetSchoolId);
      }
    },
    // 根据年制获取前置学历列表
    async getEducationListByYear() {
      if (!this.dataForm.yearSystem) {
        return;
      }
      try {
        const res = await getByTypeAndLevel({
          code: 'XL',
          year: this.dataForm.yearSystem
        });
        if (res && res.length > 0) {
          this.yxlccLists = res;
          // 如果当前选择的前置学历不在新列表中，清空选择
          const currentEducation = this.yxlccLists.find(item => item.code == this.dataForm.oldDegreeLevel);
          if (!currentEducation) {
            this.dataForm.oldDegreeLevel = '';
            this.dataForm.oldDegreeLevelName = '';
          }
        }
      } catch (error) {
        console.error('获取前置学历列表失败:', error);
      }
    },

    pdRules() {
      let age = this.getAgeFn();
      if (age < 15) {
        return false
      }
      if (this.dataForm.oldDegreeLevel == 1) {
        if (this.dataForm.yearSystem == 1) {
          // 一年制
          return false;
        }
        // 初中
        if (this.dataForm.yearSystem == 2) {
          // 两年制
          return age >= 16;
        }
        if (this.dataForm.yearSystem == 3) {
          // 三年制
          return age >= 15;
        }
        return true;
      } else {
        return !(this.dataForm.yearSystem == 1 && age < 18);
      }

      // else if (this.dataForm.oldDegreeLevel == 2) {
      //   // 高中
      //   return !(this.dataForm.yearSystem == 1 && age < 18);
      // }
      // yearSyste
    },

    async onSubmit() {
      return new Promise((resolve, reject) => {
        if (this.isDisabled) {
          resolve(this.isDisabled);
          return;
        }
        this.submitFn(resolve, reject)
      });
    },
    submitFn(resolve, reject) {
      this.$refs.dataForms
        .validate()
        .then(async () => {
          // 先获取接口数据用于弹框展示
          await this.getDisplayData();
          // 如果表单被清空（学生未报名），不再继续执行弹框
          if (!this.dataForm.name && !this.dataForm.mobilePhoneNum) {
            reject("验证码无效，请重新登录");
            return;
          }
          this.byIdentityGetBirth(this.dataForm);
          console.log('点击下一步时 identityType:', this.dataForm.identityType);
          console.log('点击下一步时 identityNum:', this.dataForm.identityNum);
          console.log('点击下一步时 oldDegreeLevel:', this.dataForm.oldDegreeLevel);
          console.log('点击下一步时 yearSystem:', this.dataForm.yearSystem);
          console.log('点击下一步时 计算年龄:', this.getAgeFn());
          if (15 > this.getAgeFn()) {
            Toast({
              message: "报名必须满15岁",
              position: "top",
            });
            reject("报名必须满15岁");
            return
          }
          if (!this.pdRules()) {
            Toast({
              message: "实际年龄与所报专业年龄要求不符",
              position: "top",
            });
            reject("实际年龄与所报专业年龄要求不符");
            return;
          }
          Dialog({
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonColor: '#323233',
            message: `<div style="text-align:left;line-height:1.8;">
              <div style="margin-bottom:8px;">请确认以下信息准确无误，<span style="color:red;">教学中心审核通过将不能修改！</span></div>
              <table style="width:100%;border-collapse:collapse;font-size:14px;">
                <tr>
                  <td style="border:1px solid #ccc;padding:8px;width:30%;"><strong>姓名</strong></td>
                  <td style="border:1px solid #ccc;padding:8px;width:70%;">${this.studentInfoData.name || this.dataForm.name || ''}</td>
                </tr>
                <tr>
                  <td style="border:1px solid #ccc;padding:8px;"><strong>手机号</strong></td>
                  <td style="border:1px solid #ccc;padding:8px;">${this.studentInfoData.mobilePhoneNum || this.dataForm.mobilePhoneNum || ''}</td>
                </tr>
                <tr>
                  <td style="border:1px solid #ccc;padding:8px;"><strong>分校</strong></td>
                  <td style="border:1px solid #ccc;padding:8px;">${ this.dataForm.branchName || ''}</td>
                </tr>
                <tr>
                  <td style="border:1px solid #ccc;padding:8px;"><strong>教学中心</strong></td>
                  <td style="border:1px solid #ccc;padding:8px;">${ this.dataForm.schoolName || ''}</td>
                </tr>
              </table>
            </div>`
          })
            .then(() => {
              
              localStorage.setItem("eleH5IdentityNum", this.dataForm.identityNum);
              localStorage.setItem(
                "eleH5IdentityType",
                this.dataForm.identityType
              );
              localStorage.setItem("eleH5SpecialtyId", this.dataForm.specialtyId);
              this.dataForm.identityNum = this.convertXToUpperCase(this.dataForm.identityNum);
              // 提交前确保 specialtyId 是字符串类型
              const submitData = { ...this.dataForm };
              if (submitData.specialtyId !== undefined && submitData.specialtyId !== null) {
                submitData.specialtyId = String(submitData.specialtyId);
              }
              saveData(submitData).then((res) => {
                this.dataForm.studentId = res || "";
                this.$store.commit("setUserId", res || "");
                resolve(this.isDisabled);
              });
            })
            .catch(() => {
              // 点击取消，清除用户填写的信息
              let kongObj = {
                name: "", // 姓名
                identityType: "", // 证件类型
                identityTypeName: "", // 证件类型名称
                identityNum: "", // 证件号码
                email: "", // 邮箱
                mobilePhoneNum: "", // 手机号码
                code: "", // 验证码
                oldDegreeLevel: "", // 前置学历
                oldDegreeLevelName: "", // 前置学历名称
                branchId: "", // 所在分校id
                branchName: "", // 所在分校名称
                schoolId: "", // 教学中心
                schoolName: "", // 教学中心名称
                specialtyId: "", // 专业名称
                specialtyName: "", // 专业名称
                yearSystem: "", // 年制
                yearSystemName: "", // 学制名称
                planId: "", // 计划id
                planName: "", // 计划名称
                classId: "", // 班级
                studentId: "", // 学生ID
              };
              Object.keys(kongObj).forEach((key) => {
                this.dataForm[key] = kongObj[key];
              });
              // 重置禁用状态
              this.isDisabled = false;
              // 清除验证码倒计时
              if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
                this.codeNum = 60;
              }
              // 清除Vuex中的登录状态，让用户重新填写个人信息
              this.$store.commit("setToken", "");
              this.$store.commit("setUserId", "");
              this.$store.commit("setStudentNo", "");
              // 清除localStorage中的相关信息
              localStorage.removeItem("eleH5IdentityNum");
              localStorage.removeItem("eleH5IdentityType");
              localStorage.removeItem("eleH5SpecialtyId");
              localStorage.clear();
              // 清除弹框展示的接口数据
              this.studentInfoData = {};
              Toast({
                message: "请填写信息",
                position: "top",
              });
            })
          // 验证通过
        })
        .catch((err) => {
          Toast({
            message: "请完善信息",
            position: "top",
          });
          //验证失败
        });
    },
    convertXToUpperCase(idNumber) {
      // 使用正则表达式查找小写的 'x'
      const hasLowerCaseX = /x/i.test(idNumber);

      if (hasLowerCaseX) {
        // 将小写的 'x' 转换为大写的 'X'
        return idNumber.toUpperCase();
      }

      // 如果没有小写的 'x'，则返回原始身份证号
      return idNumber;
    },
    rulesMobilePhoneNum(val) {
      return isMobile(val);
    },
    // 通过身份证获取出生年月性别
    byIdentityGetBirth(data) {
      let idNo = data.identityNum;
      //获取出生年月
      let str1 = idNo.substring(6, 10);
      let str2 = idNo.substring(10, 12);
      let str3 = idNo.substring(12, 14);
      // 性别
      if (str1 && str2 && str3) {
        data.birthDate = `${str1}-${str2}-${str3}`;
      }
      // 0 男 1：女
      let num = idNo.charAt(16);
      data.gender = num % 2 == 0 ? "1" : "0";
    },

    rulesIdentityNum(val) {
      return val.length === 18;
      // return idCardValidity(val)
    },
    rulesEmail(val) {
      return checkEmail(val)
    },
    // 清除第二页（improveInfor）和第三页（Sign）的数据
    clearOtherPageData() {
      // 清除Vuex中存储的其他页面数据
      this.$store.commit("setIdCard", {});
      this.$store.commit("setPreposeDiploma", "");
      this.$store.commit("setWorkCertificate", "");
      this.$store.commit("setPhoto", "");
      // 如果父组件index.vue有引用improveInfor和sign组件，调用其重置方法
      if (this.$parent && this.$parent.$refs) {
        // 清除第二页 improveInfor 的数据
        if (this.$parent.$refs.improveInfor) {
          const improveInfor = this.$parent.$refs.improveInfor;
          // 重置 improveInfor 的 dataForm
          const improveKongObj = {
            nation: '', // 民族
            nationName: '', // 民族名称
            politicalStatus: '', // 政治面貌
            politicalStatusName: '', // 政治面貌名称
            ancestralNativeType: '', // 户口性质
            ancestralNativeTypeName: '', // 户口性质名称
            residentProvince: '', // 户籍省
            residentPrefecturalCity: '', // 户籍市
            communicationProvince: '', // 通讯地址省份
            communicationPrefecturalCity: '', // 通讯地址城市
            communicationGroundArea: '', // 通讯地址城市
            communicationStreet: '', // 通讯地址街道
            communicationDetailedAddress: '', // 详细地址
            preposeDiploma: '',  // 前置学历证书图片
            oldGraduated: '', // 原毕业学校
            workCertificate: '', // 工作证明图片
            identityCardFront: '', // 身份证正面
            identityCardBack: '', // 身份证反面
            photo: '', // 证件照
          };
          Object.keys(improveKongObj).forEach((key) => {
            improveInfor.dataForm[key] = improveKongObj[key];
          });
          // 重置其他状态
          improveInfor.residentValue = '';
          improveInfor.fieldValue = '';
          improveInfor.birthDateValue = new Date();
        }
        // 清除第三页 Sign 的数据
        if (this.$parent.$refs.sign) {
          const sign = this.$parent.$refs.sign;
          sign.dataForm.isSignature = 0;
          sign.dataForm.signatureImage = null;
          sign.dataForm.regAddress = "";
          sign.dataForm.signAddress = "";
          sign.checkbox = false;
          // 清除签名板
          if (sign.$refs.signaturePad) {
            sign.$refs.signaturePad.clearSignature();
          }
        }
      }
    },
  },
};
</script>
<style>
.nameBrance {
  display: inline-block;
  color: red;
}
</style>
<style scoped>
.van-cell::after {
  border-bottom: 1px solid #ddd;
}

.formData .modulesWrap {
  margin-bottom: 10px;
  border-radius: 10px;
  overflow: hidden;
  background-color: #fff;
}

.formData .cardWrap {
  background: #fff;
  padding: 18px 13px 10px;
}

.formData .cardTitle {
  padding-left: 10px;
  font-size: 20px;
  font-weight: 500;
  color: #333333;
  line-height: 30px;
  position: relative;
}

.formData .cardTitle::before {
  position: absolute;
  content: "";
  top: 50%;
  left: 0;
  width: 4px;
  height: 15px;
  background: #c1121e;
  border-radius: 2px;
  transform: translateY(-50%);
}

.formData .twoTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.formData .twoTitle img {
  width: 20px;
  margin-right: 10px;
}

.formData .twoTitle .ditu {
  display: flex;
  align-items: center;
}

.formData .degreeTip {
  text-indent: 32px;
  color: red;
  padding: 0 10px;
  margin-top: 20px;
}

.formData .tip {
  font-size: 13px;
  font-weight: 400;
  color: #D02B3A;
  line-height: 26px;
  background-color: #fff;
  padding: 10px 0 10px 16px;
}

.formData .majorChange {
  box-sizing: border-box;
  display: flex;
  margin: 0 10px;
  height: 50px;
  margin-top: 10px;
}

.formData .majorChange .morenMajor {
  position: relative;
  flex: 1;
  text-align: center;
  line-height: 50px;
  font-size: 17px;
}

.formData .majorChange .morenMajor:nth-child(1)::after {
  position: absolute;
  top: 16px;
  height: 16px;
  right: 0;
  content: "";
  width: 0;
  border-left: solid darkblue 1px;
}

.formData .majorChange .addMajor {
  color: red;
}

.next {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  position: fixed;
  z-index: 0;
  bottom: 0;
  width: 100%;
  height: 60px;
  padding: 0 10px;
  background-color: #fff;
}

.next .nextBtn {
  background-color: red;
  border: none;
  font-size: 18px;
  font-weight: bold;
}

/* .cardContent /deep/ .van-field__label {
  font-size: 15px;
  font-weight: 400;
  color: #333333;
}
.van-cell {
  flex: 1;
}
.phoneNumber {
  width: 90px;
  line-height: 40px;
  background: #d62d27;

  border-radius: 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 400;
  padding: 0;
  text-align: center;
}
.disabaled {
  background: #d5d5d5;
} */
/* .fbBox {
  padding-bottom: 10px;
}
.tipfb {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 28px;
  margin-left: 10px;
  flex: 1;
}
.alignCenter {
  align-items: center;
}
.flexStart {
  justify-content: flex-start;
}
.tipfb .subTip {
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 15px;
}
.tipImg {
  display: block;
  width: 16px;
}
.schoolWrap {
  border-radius: 10px;
}
.dizhi {
  display: block;
  width: 16px;
  margin-right: 10px;
}
.schoolSelect {
  flex: 1;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 20px;
}
.schoolSelect span {
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 18px;
}
.searchBox {
  border-radius: 5px;
  padding: 10px;
  font-size: 13px;
  line-height: 13px;
  flex: 1;
}
.serchBtn {
  width: 50px;
  text-align: center;
  border-radius: 5px;
  margin-left: 10px;
}
.noData {
  text-align: center;
  font-size: 12px;
  color: #999999;
}
.selectType {
  margin: 10px;
  font-size: 14px;
  line-height: 28px;
}
.selectType .checked {
  color: #d62d27;
}
.van-cell--required::before {
  left: -8px;
} */
</style>
